import script from "./Configs.vue?vue&type=script&setup=true&lang=js"
export * from "./Configs.vue?vue&type=script&setup=true&lang=js"

import "./Configs.vue?vue&type=style&index=0&id=47e79f18&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_mcn_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e79f18"]])

export default __exports__